import axiosInstance from "../../../middlewares/axiosInstance";
import { AxiosResponse } from "axios";

export interface ProcessedItem {
  _id: string;
  processed_item_id: string;
  name: string;
  description?: string;
  category?: string;
  recipe_id: string;
  batch_number: string;
  quantity: number;
  remaining_quantity: number;
  unit: string;
  production_date: number;
  expiry_date: number;
  cost_per_unit: number;
  total_cost: number;
  storage_place?: string;
  storage_instructions?: string;
  is_active: boolean;
  is_deleted: boolean;
  store_id: string;
  created_at: number;
  created_by: string;
  updated_at: number;
  updated_by: string;
  api_batch_id: string;
  ingredients: Array<{
    batch_id: string;
    cost: number;
    ingredient_id: string;
    is_matching_recipe: boolean;
    quantity: number;
    unit: string;
  }>;
  consumption_logs: Array<{
    timestamp: number;
    quantity: number;
    remaining_quantity: number;
    action: "produce" | "consume" | "waste" | "adjust";
    performed_by: string;
    notes?: string;
  }>;
}

interface ListParams {
  searchQuery?: string;
  filters?: Array<{
    id: string;
    title: string;
    field: string;
    operator: string;
    value: any;
  }>;
  startDate?: number;
  endDate?: number;
  dateField?: string;
  sortField?: string;
  sortOrder?: "asc" | "desc";
  pageIndex: number;
  pageSize: number;
  category?: string;
  recipe_id?: string;
  include_depleted?: boolean;
}

interface ListResponse {
  data: ProcessedItem[];
  metadata: {
    total: {
      value: number;
    };
    took: number;
    timed_out: boolean;
    max_score: number | null;
  };
}

interface CreateProcessedItemData {
  name: string;
  description?: string;
  category?: string;
  recipe_id: string;
  api_batch_id: string;
  quantity: number;
  unit: string;
  production_date: number;
  expiry_date: number;
  storage_place?: string;
  storage_instructions?: string;
}

interface UpdateProcessedItemData {
  _id: string;
  name?: string;
  description?: string;
  category?: string;
  storage_place?: string;
  storage_instructions?: string;
  is_active?: boolean;
}

interface ConsumeProcessedItemData {
  _id: string;
  quantity: number;
  notes?: string;
}

export interface ConsumeProcessedItemsRequest {
  items: {
    _id: string;
    quantity: number;
    notes?: string;
  }[];
}

class ProcessedItemsService {
  private readonly baseUrl = "/business-admin/processed-items";

  async listProcessedItems(params: ListParams): Promise<any> {
    const response = await axiosInstance.post(`${this.baseUrl}/list`, params);
    return response.data.data;
  }

  async getProcessedItem(_id: string): Promise<AxiosResponse<ProcessedItem>> {
    const response = await axiosInstance.post(`${this.baseUrl}/get`, {
      _id: _id,
    });
    return response;
  }

  async createProcessedItem(
    data: CreateProcessedItemData
  ): Promise<AxiosResponse<ProcessedItem>> {
    console.log("data");
    console.log(data);
    const response = await axiosInstance.post(`${this.baseUrl}/create`, data);
    return response;
  }

  async updateProcessedItem(
    data: UpdateProcessedItemData
  ): Promise<AxiosResponse<ProcessedItem>> {
    const response = await axiosInstance.post(`${this.baseUrl}/update`, data);
    return response;
  }

  async deleteProcessedItem(_id: string): Promise<AxiosResponse<null>> {
    const response = await axiosInstance.post(`${this.baseUrl}/delete`, {
      _id: _id,
    });
    return response;
  }

  async consumeProcessedItem(
    data: ConsumeProcessedItemData
  ): Promise<AxiosResponse<null>> {
    const response = await axiosInstance.post(`${this.baseUrl}/consume`, data);
    return response;
  }

  async wasteProcessedItem(
    data: ConsumeProcessedItemData
  ): Promise<AxiosResponse<null>> {
    const response = await axiosInstance.post(`${this.baseUrl}/waste`, data);
    return response;
  }

  async adjustProcessedItem(
    data: ConsumeProcessedItemData
  ): Promise<AxiosResponse<null>> {
    const response = await axiosInstance.post(`${this.baseUrl}/adjust`, data);
    return response;
  }

  async consumeProcessedItems(
    data: ConsumeProcessedItemsRequest
  ): Promise<AxiosResponse<null>> {
    if (!data.items || data.items.length === 0) {
      console.log("No processed items to consume, skipping API call");
      return Promise.resolve({
        data: null,
        status: 200,
        statusText: "OK",
        headers: {},
        config: { headers: {} as any } as any,
      });
    }
    const response = await axiosInstance.post(
      `${this.baseUrl}/consume-processed-item`,
      data
    );
    return response;
  }
}

export const processedItemsService = new ProcessedItemsService();
